import { trustedBy } from "@/lib/home-content";
import InfiniteMarquee from "@/components/InfiniteMarquee";

export default function TrustedBy() {
    return (
        <section className="bg-white px-0 py-10 sm:py-12">
            <p className="mb-6 px-5 text-center text-xs font-semibold uppercase tracking-[0.16em] text-[#8a8a95]">
                {trustedBy.label}
            </p>
            <div className="relative overflow-hidden">
                <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-white to-transparent" />
                <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-white to-transparent" />
                <InfiniteMarquee groupClassName="gap-10 pr-10" duration={36}>
                    {trustedBy.logos.map((name) => (
                        <span
                            key={name}
                            className="whitespace-nowrap font-display text-xl font-bold text-[#b9b9c4] sm:text-2xl"
                        >
                            {name}
                        </span>
                    ))}
                </InfiniteMarquee>
            </div>
        </section>
    );
}
